module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_20000-06409ca162e09fe61fcb106d3baca9b6.png";